import { ReactComponent as IconFolder } from "@/assets/svgs/package-folder-icon.svg";
import { ReactComponent as IconPinToTop } from "@/assets/svgs/pin-solid-small.svg";
import MultiLevelDropDown from "@/components/MultiLevelMenuDropDown/index.js";
import { ToastContext } from "@/context/toast/index";
import useModal from "@/hooks/use-modal/index";
import packageApi from "@/services/api/packages.js";
import { useContext, useEffect, useState } from "react";
import MultiClamp from 'react-multi-clamp';
import { useNavigate } from '@/lib/router-dom'
import DeletePackageFolderModal from "./delete-package-folder-modal.jsx";
import RenamePackageFolderModal from "./rename-package-folder-modal.jsx";
import DownloadAllDataModal from "./download-all-data-modal.jsx";
import PropTypes from 'prop-types';

export default function PackageFolderCard({
	moveToFolder,
	item,
	refreshData,
	setRefreshData
}) {
	const packageActivity = "folder";
	const { goTo } = useNavigate();
	const { addToastMessage } = useContext(ToastContext);

	const [isDragOver, setIsDragOver] = useState(false);
	const [isPinned, setIsPinned] = useState(item.pinned);

	const { visible: isDownloadAllModalVisible, hide: hideDownloadAllModal, show: showDownloadAllModal } = useModal();

	const {
		visible: isShowRenameFolderModal,
		show: showRenameFolderModal,
		hide: hideRenameFolderModel,
	} = useModal();

	const {
		visible: isShowDeleteFolderModal,
		show: showDeleteFolderModal,
		hide: hideDeleteFolderModal,
	} = useModal();

	useEffect(() => {
		setIsPinned(item.pinned);
	}, [item]);

	const handlePin = async () => {

		const [error] = await packageApi.pinPackage(isPinned ? "unpin" : "pin", {
			eclipFolderId: item.id
		});

		if (error) {
			return addToastMessage(isPinned ? "Pin not removed" : "Pin not added", 'error')
		}

		setRefreshData(!refreshData)

		addToastMessage(
			isPinned ? "Removed pin successfully" : "Pinned successfully",
			"success"
		);
	};

	const veridaptMenu = [
		{
			label: "Download",
			onClick: (e) => {
				e.stopPropagation();
				showDownloadAllModal();
			},
		},
		{
			label: isPinned ? "Unpin" : "Pin",
			onClick: (e) => {
				e.stopPropagation();
				handlePin();
			},
		}
	]
	const nonVeridaptmenu = [
		{
			label: "Download",
			onClick: (e) => {
				e.stopPropagation();
				showDownloadAllModal();
			},
		},
		{
			label: "Rename",
			onClick: (e) => {
				e.stopPropagation();
				showRenameFolderModal();
			},
		},
		{
			label: isPinned ? "Unpin" : "Pin",
			onClick: (e) => {
				e.stopPropagation();
				handlePin();
			},
		},
		{
			label: "Delete",
			labelColor: "#A72E12",
			onClick: (e) => {
				e.stopPropagation();
				showDeleteFolderModal();
			},
		},
	]

	return (
		<>
			<div
				data-testid="folder-item"
				className={
					"package-folder-card" +
					(isDragOver ? " drag-over" : "")
				}
				onClick={() => goTo(`/package/folder/${item.id}`, { isVeridaptFolder: item.isVeridapt })}
				onDrop={(ev) => {
					ev.preventDefault();
					const data = ev.dataTransfer.getData("text/plain");
					const veridaptPackage = JSON.parse(ev.dataTransfer.getData("veridaptPackage"))
					if (item.isVeridapt) {
						return addToastMessage("Package is not allow to add to Veridapt folder", "error");
					}
					if (veridaptPackage) {
						return addToastMessage("Package is not allow to move to folder", "error");
					}
					moveToFolder(data, { folderId: item?.id });
					setIsDragOver(false);
				}}
				onDragOver={(ev) => {
					ev.preventDefault();
					setIsDragOver(true);
				}}
				onDragLeave={(ev) => {
					ev.preventDefault();
					setIsDragOver(false);
				}}
			>

				<div className="package-folder-card__icon--non-veridapt"><IconFolder /></div>
				<div className="package-folder-card__name tooltip">
					<MultiClamp clamp={2}>{item.name}</MultiClamp>
					<span className={"tooltiptext__package-folder-name"}>
						{item.name}
					</span>
				</div>
				<div className="package-folder-card__folder-pin">{isPinned && <IconPinToTop />}</div>
				<div className="package-landing__folder-menu">
					< MultiLevelDropDown
						menuList={item.isVeridapt ? veridaptMenu : nonVeridaptmenu}
					/>
				</div>
			</div>

			<RenamePackageFolderModal
				visible={isShowRenameFolderModal}
				close={hideRenameFolderModel}
				data={item}
			/>

			<DeletePackageFolderModal
				visible={isShowDeleteFolderModal}
				close={hideDeleteFolderModal}
				id={item?.id}
			/>

			<DownloadAllDataModal
				visible={isDownloadAllModalVisible}
				close={hideDownloadAllModal}
				all={true}
				isFolder={true}
				downloadName={item?.name}
				packageActivity={packageActivity}
				downloadId={[item?.id]}
				isVeridapt={item.isVeridapt}
			/>
		</>
	);
}

PackageFolderCard.propTypes = {
	moveToFolder: PropTypes.func,
	item: PropTypes.any,
	refreshData: PropTypes.any,
	setRefreshData: PropTypes.func,
};
